<template>
  <div class="login">
    <p class="loginTitle">{{ title }}</p>
    <p class="loginDiscribe">{{ discribe }}</p>
    <div class="reportLogin">
      <div class="reportLogin-title">公众举报平台</div>
      <el-button class="reportLogin-button" type="primary" @click="TurnReport"
        >登录</el-button
      >
    </div>
    <div class="login-form">
      <div class="login-form-title">
        <div class="title-left">欢迎来到<br/>{{ title }}</div>
        <div class="title-center"></div>
        <div class="title-right">Login please</div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="密码登录" name="first">
          <PassWordLogin :reset="reset1" :towncode="towncode" />
        </el-tab-pane>
        <el-tab-pane label="手机登录" name="second">
          <PhoneLogin :reset="reset2" :towncode="towncode" />
        </el-tab-pane>
      </el-tabs>
      <el-image
        class="login-form-bg"
        :src="require('@/assets/images/loginIcon.png')"
      ></el-image>
    </div>
  </div>
</template>

<script>
import PassWordLogin from "./PassWordLogin.vue";
import PhoneLogin from "./PhoneLogin.vue";
export default {
  name: "Login",
  // vue 页面刷新
  inject: ["reload"],
  components: {
    PassWordLogin,
    PhoneLogin,
  },
  data() {
    return {
      activeName: "first",
      reset1: false,
      reset2: false,
      title: "湘江私募基金管理服务平台",
      discribe:
        "创新服务模式，全周期一站式服务与省级、湘江新区专项扶持政策同步发力，让机构能享实惠，长足发展",
      towncode: "",
    };
  },
  methods: {
    handleClick(tab, event) {
      // this.title = tab.name == "first" ? "湘江私募基金管理服务平台" : "公众举报平台";
      this.title =
        tab.name == "first" ? "湘江私募基金管理服务平台" : "湘江私募基金管理服务平台";
    },
    TurnReport() {
      this.$router.push({
        path: "/reportLogin",
        query: {
          TownCode: this.$route.query.TownCode,
        },
      });
    },
  },
  mounted() {
    console.log(this.$route.query.TownCode);
    if (this.$route.query.TownCode) {
      this.towncode = this.$route.query.TownCode;
    }
  },
  watch: {
    activeName(newValue, old) {
      if (newValue == "first") {
        this.reset1 = true;
        this.reset2 = false;
      } else {
        this.reset1 = false;
        this.reset2 = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  ::v-deep .el-tab-pane {
    overflow: visible;
  }
  .reportLogin {
    position: absolute;
    top: 3vh;
    right: 11.63vw;
    display: flex;
    align-items: center;
    &-title {
      font-size: 1.25vw;
      font-family: AlibabaM;
      color: #ffffff;
      line-height: 3vh;
    }
    &-button {
      margin-left: 0.5vw;
      width: 4.875vw;
      height: 1.75vw;
      background: #3099fc;
      border-radius: 0.375vw;
      padding: 0;
      font-size: 1vw;
      font-family: AlibabaM;
      color: #ffffff;
    }
  }
  &-form {
    width: 456px;
    // height: 512px;
    border-radius: 16px;
    box-shadow: 3px 5px 7px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    position: absolute;
    right: 11.63vw;
    background: #ffffff;
    top: 42vh;
    margin-top: -250px;
    &-title {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      margin-bottom: 11px;
      margin-top: 23px;
      justify-content: center;
      .title-left {
        font-size: 24px;
        font-family: AlibabaB;
        text-align: left;
        color: #191818;
        line-height: 33px;
      }
      .title-center {
        margin-left: 6px;
        width: 4px;
        height: 20px;
        background: #3099fc;
        border-radius: 3px;
      }
      .title-right {
        font-size: 18px;
        font-family: Alibaba;
        margin-left: 10px;
        text-align: left;
        color: #191818;
        line-height: 25px;
      }
    }
    &-bg {
      height: 325px;
      width: 281px;
      position: absolute;
      top: -157px;
      left: -79px;
      z-index: 1;
    }

    ::v-deep  .el-tabs__nav {
      transform: translateX(-50%) !important;
      left: 50%;
      color: #6c7885 !important;
    }
    ::v-deep  .el-tabs__active-bar {
      background-color: #3165ff !important;
      height: 4px;
      background: #008fff;
      border-radius: 3px;
    }
    ::v-deep  .el-tabs__nav .el-tabs__item {
      font-size: 16px;
      color: #6c7885;
    }
    ::v-deep  .el-tabs__item.is-active {
      color: #3165ff !important;
    }
    ::v-deep .el-tabs__nav-wrap::after {
      background-color: transparent;
    }
    ::v-deep .el-tabs__content {
      padding: 0 47px;
    }
  }
}
</style>